/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { Card, WingBlank, WhiteSpace } from "antd-mobile";
import { connect } from "react-redux";
import QRCode from "qrcode.react";
import * as _ from "underscore";
import * as meAction from "../../actions/me";
import * as selectors from "../../selectors";
import * as userSelectors from "../../selectors/user";
import LoadingIndicator from "../../components/LoadingIndicator";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  overflow-y: scroll;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledQrContainer = styled.div`
  margin-top: 5px;
`;

class MyQrcodePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationClass: null
    };
  }

  componentDidMount() {
    this.configureNavBar();
    this.setState({ animationClass: "slide-in-right" });
    this.fetchProfileData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.authToken !== this.props.authToken) {
      if (nextProps.authToken) {
        this.fetchProfileData();
      }
    }
  }

  fetchProfileData = () => {
    const { getMeData, authToken, meData } = this.props;

    if (authToken && _.isEmpty(meData)) {
      getMeData && getMeData();
    }
  };

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <FormattedMessage
        id="profile.my.qrcode.title"
        defaultMessage="My QR Code"
      />
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed(), null);
    showNavbar(true);
    showTabbar(false);
  };

  getLoadingIndicator = () => {
    const { loading } = this.props;

    return loading ? <LoadingIndicator /> : false;
  };

  onBackPressed = () => {
    const { history } = this.props;

    this.setState({ animationClass: "slide-out-right" });
    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  render() {
    const { animationClass } = this.state;
    const { meData } = this.props;
    const username = userSelectors.getUserName(meData);
    const qrString = userSelectors.getUserQrString(meData);
    const qrImage = userSelectors.getUserQrImage(meData);

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        <WingBlank size="lg" style={{ marginTop: "20px", width: "90%" }}>
          <WhiteSpace size="md" />
          <Card style={{ boxShadow: "0 4px 6px -5px grey" }}>
            <Card.Header
              style={{ padding: "15px 10px" }}
              title={username}
              // thumb={
              //   <img
              //     src={require("../../assets/icons/user.png")}
              //     style={{ width: "2em", marginRight: "10px" }}
              //   />
              // }
            />
            <Card.Body>
              <StyledQrContainer>
                {!_.isEmpty(qrString) ? (
                  <QRCode
                    style={{ width: "80%", padding: "10px 0" }}
                    level="M"
                    size={256}
                    renderAs="svg"
                    value={qrString}
                  />
                ) : (
                  false
                )}
              </StyledQrContainer>
            </Card.Body>
          </Card>
          <WhiteSpace size="md" />
        </WingBlank>
      </StyledContainer>
    );
  }
}

MyQrcodePage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  authToken: PropTypes.string,
  meData: PropTypes.object,
  loading: PropTypes.bool,
  getMeData: PropTypes.func
};

function mapStateToProps(state) {
  return {
    authToken: selectors.getAuthToken(state),
    meData: selectors.getMeData(state),
    loading: selectors.getMeLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getMeData: () => dispatch(meAction.getMeDataRequest())
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MyQrcodePage)
);



// WEBPACK FOOTER //
// ./src/containers/MyQrcodePage/index.js